import React, { FunctionComponent } from 'react';
import { Card, LoadingIndicator as LoadingSpinner } from '@mlc/web-ui-toolkit';
import CommonIds from './Common.elements';

const LoadingIndicator: FunctionComponent = () => (
	<Card
		data-id={CommonIds.loadingIndicator}
		display="flex"
		justifyContent="center"
		containerSize="thick"
	>
		<div style={{ width: '100px' }} data-id={'loadingIndicator'}>
			<LoadingSpinner variant="scaled" colorTheme="dark" />
		</div>
	</Card>
);

export default LoadingIndicator;
